/**
 * Domain Blog Hits Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.domainBlogHitsFormatter = function(value, row) {
    let html = '';
    html += '<a href="/domains/show/statistics/'+row.domain_id+'?filter_request_uri[]=/blog/'+row.slug+'" target="_index">';
    html += value;
    html += "</a>";
    return html;
};
